import { useApi } from "hooks/useApis";
import FillErrorAlert from "components/Alerts/FillErrorAlert";
import IconButton from "components/Buttons/IconButton"

import { useState } from "react";
import { CircularProgress } from "@mui/material"
import { FileDownload as FileDownloadIcon } from "@mui/icons-material";
import { AxiosError } from "axios";

export const DownloadPayrollButton = ({
  payrollId
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState("");

  const api = useApi();

  const handleDownload = async () => {
    if (!payrollId) {
      setDownloadError("URL do arquivo não está disponível.");
      return;
    }

    setIsDownloading(true);
    try {
      await api.downloadPayrollCSV(payrollId);
    } catch (error) {
      console.error("Erro ao baixar o arquivo:", error);
      setDownloadError("Erro ao baixar o arquivo. Tente novamente.");
    } finally {
      setIsDownloading(false);
    }
  };


  return (
    <>
      {isDownloading ? (
        <CircularProgress />
      ) : (
        <IconButton
          onClick={handleDownload}
          text="Baixar lista"
          icon={<FileDownloadIcon></FileDownloadIcon>}
        />
      )}

      <FillErrorAlert
        open={downloadError !== ""}
        onClose={() => setDownloadError("")}
        title="Erro ao baixar planilha."
        message={downloadError}
      />
    </>
  );
}
